export { default } from './InternalIdentifier'
export * as S from './InternalIdentifier.styles'
